import {generateInitialState} from "@/helpers/generateInitialState";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {partnersInitialState} from "../initialStates";
import {loadPartnerDetails} from "./partnersActions";

const initialState = await generateInitialState("partners", partnersInitialState);

const partnersSlice = createSlice({
  name: "partners",
  initialState,
  reducers: {
    updatePartnerDetails: (state, action) => {
      state.data = {...action.payload};
      state.isFetching = false;
      state.hasFailed = false;
      state.errorMsg = "";
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadPartnerDetails.fulfilled, (state, action) => {
        state.data = {...action.payload};
        state.isFetching = false;
        state.hasFailed = false;
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadPartnerDetails.rejected), (state, action) => {
        const {message = "Something went wrong"} = action.payload || {};

        state.hasFailed = true;
        state.isFetching = false;
        state.errorMsg = message;
      })
      .addMatcher(isAnyOf(loadPartnerDetails.pending), (state, action) => {
        state.hasFailed = false;
        state.isFetching = true;
        state.errorMsg = "";
      });
  },
  selectors: {
    partnerDetailsSelector: state => state.data,
    partnerStatusSelector: state => ({
      isFetching: state.isFetching,
      hasFailed: state.hasFailed,
      errorMsg: state.errorMsg,
    }),
  },
});

export const {updatePartnerDetails} = partnersSlice.actions;
export const {partnerDetailsSelector, partnerStatusSelector} = partnersSlice.selectors;
export default partnersSlice.reducer;
